/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="bx:reset">
      <path
        id="Vector"
        d="M10 13C11.114 13 12 12.1127 12 11C12 9.88733 11.114 9 10 9C8.886 9 8 9.88733 8 11C8 12.1127 8.886 13 10 13Z"
        fill="#7876C1"
      />
      <path
        id="Vector_2"
        d="M15.878 9.43019C15.7209 8.62404 15.4139 7.85833 14.9747 7.1769C14.543 6.50649 13.9931 5.92909 13.3547 5.4759C12.7056 5.01483 11.9764 4.69252 11.2087 4.5274C10.8054 4.44153 10.3948 4.39931 9.98333 4.4014V3L7.33333 5.1L9.98333 7.2V5.8014C10.306 5.8 10.6287 5.8322 10.94 5.8994C11.5367 6.02778 12.1034 6.27824 12.608 6.6365C13.1056 6.98877 13.5338 7.43843 13.8693 7.9609C14.3902 8.76955 14.668 9.72375 14.6667 10.7C14.6665 11.3551 14.5419 12.0036 14.3 12.6075C14.1824 12.8984 14.0386 13.1768 13.8707 13.4391C13.7021 13.6998 13.5106 13.9433 13.2987 14.1664C12.6533 14.8427 11.8341 15.3066 10.9413 15.5013C10.3205 15.6329 9.68084 15.6329 9.06 15.5013C8.46303 15.3728 7.89602 15.1221 7.39133 14.7635C6.89432 14.4115 6.46653 13.9624 6.13133 13.4405C5.61104 12.631 5.33314 11.6766 5.33333 10.7H4C4.00071 11.9556 4.35792 13.1824 5.026 14.2238C5.4579 14.8931 6.00724 15.4699 6.64466 15.9234C7.63508 16.6272 8.80407 17.0023 10 17C10.4062 17 10.8113 16.957 11.2093 16.8719C11.9765 16.7056 12.7053 16.3834 13.3547 15.9234C13.6735 15.6978 13.9707 15.4402 14.242 15.1541C14.5137 14.8681 14.7592 14.5559 14.9753 14.2217C15.6451 13.182 16.002 11.9552 16 10.7C16 10.2735 15.9591 9.8481 15.878 9.43019Z"
        fill="#C7BCE4"
      />
    </g>
  </svg>
);

const AIResetIcon = (props) => <Icon component={svg} {...props} />;

export default AIResetIcon;
